export var DEFAULT_SYNTAX = 'javascript';
export var NO_SYNTAX = 'raw';
var LANGUAGES = [{
  id: 'bash',
  prismLanguage: 'bash',
  name: 'Bash'
}, {
  id: 'c',
  prismLanguage: 'c',
  name: 'C'
}, {
  id: 'coffeescript',
  prismLanguage: 'coffeescript',
  name: 'CoffeeScript'
}, {
  id: 'cpp',
  prismLanguage: 'cpp',
  name: 'C++'
}, {
  id: 'csharp',
  prismLanguage: 'csharp',
  name: 'C#'
}, {
  id: 'css',
  prismLanguage: 'css',
  name: 'CSS'
}, {
  id: 'docker',
  prismLanguage: 'docker',
  name: 'Docker'
}, {
  id: 'elixir',
  prismLanguage: 'elixir',
  name: 'Elixir'
}, {
  id: 'erlang',
  prismLanguage: 'erlang',
  name: 'Erlang'
}, {
  id: 'git',
  prismLanguage: 'git',
  name: 'Git'
}, {
  id: 'go',
  prismLanguage: 'go',
  name: 'Go'
}, {
  id: 'graphql',
  prismLanguage: 'graphql',
  name: 'GraphQL'
}, {
  id: 'haml',
  prismLanguage: 'haml',
  name: 'HAML'
}, {
  id: 'haskell',
  prismLanguage: 'haskell',
  name: 'Haskell'
}, {
  id: 'html',
  prismLanguage: 'html',
  name: 'HTML'
}, {
  id: 'java',
  prismLanguage: 'java',
  name: 'Java'
}, {
  id: 'javascript',
  prismLanguage: 'javascript',
  name: 'JavaScript'
}, {
  id: 'json',
  prismLanguage: 'json',
  name: 'JSON'
}, {
  id: 'kotlin',
  prismLanguage: 'kotlin',
  name: 'Kotlin'
}, {
  id: 'latex',
  prismLanguage: 'latex',
  name: 'LaTeX'
}, {
  id: 'makefile',
  prismLanguage: 'makefile',
  name: 'Makefile'
}, {
  id: 'markdown',
  prismLanguage: 'markdown',
  name: 'Markdown'
}, {
  id: 'matlab',
  prismLanguage: 'matlab',
  name: 'Matlab'
}, {
  id: 'nginx',
  prismLanguage: 'nginx',
  name: 'Nginx'
}, {
  id: 'objectivec',
  prismLanguage: 'objectivec',
  name: 'ObjectiveC'
}, {
  id: 'perl',
  prismLanguage: 'perl',
  name: 'Perl'
}, {
  id: 'plaintext',
  prismLanguage: 'raw',
  name: 'Plain text'
}, {
  id: 'php',
  prismLanguage: 'php',
  name: 'PHP'
}, {
  id: 'python',
  prismLanguage: 'python',
  name: 'Python'
}, {
  id: 'r',
  prismLanguage: 'r',
  name: 'R'
}, {
  id: 'raw',
  prismLanguage: 'raw',
  name: 'Raw'
}, {
  id: 'ruby',
  prismLanguage: 'ruby',
  name: 'Ruby'
}, {
  id: 'sql',
  prismLanguage: 'sql',
  name: 'SQL'
}, {
  id: 'swift',
  prismLanguage: 'swift',
  name: 'Swift'
}, {
  id: 'typescript',
  prismLanguage: 'typescript',
  name: 'TypeScript'
}, {
  id: 'markup',
  prismLanguage: 'markup',
  name: 'XML'
}, {
  id: 'yaml',
  prismLanguage: 'yaml',
  name: 'YAML'
}];
export default LANGUAGES;
export function findLanguage(languageId) {
  return LANGUAGES.find(function (language) {
    return language.id === languageId;
  });
}